import api from "./services/mkm.api.js"

const resource = "/altersgruppe"

export default{
    alle() {
        return api.get(`${resource}`);
    }
}